import isCMSDashboard from 'ui/helpers/utils/isCMSDashboard';
const promoPageView = (params) => {
  // will ignore layer push when inside CMS path (CMS dashboard)
  if (params && params.length > 0 && !isCMSDashboard()) {
    const dataCategory = params.map((data) => ({ ...data, category: data.category }));
    if (typeof window !== 'undefined') {
      params.forEach((data) => delete data.category);
      (window as any)?.dataLayer?.push({
        event: 'promotionView',
        eventCategory: 'ecommerce promotion',
        eventLabel: `${
          (dataCategory?.every((val) => val?.category === dataCategory[0]?.category)
            ? dataCategory?.[0]?.category
            : 'semua') ?? 'semua'
        }`,
        ecommerce: {
          promoView: {
            promotions: params,
          },
        },
      });
    }
  }
};
export default promoPageView;
